import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import firebase_connection from '../backend/firebase';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import error_handler from '../ErrorHandler'

class Main extends Component {
    constructor(props) {
        super(props);
        this.state = { organizations: [], dialog_open: false };
    }

    componentWillMount(){
        this.messagesRef = firebase_connection.database().ref('user_orgs/'+this.props.user.uid);
        this.messagesRef.on('child_added', snapshot => {
            firebase_connection.database().ref('organizations/'+snapshot.key).once('value', ordData => {
                let org = { org: ordData.val(), id: ordData.key };
                this.setState(previousState => { organizations: previousState.organizations.push(org); });
            }, error_handler)
        }, error_handler)
    }

    componentWillUnmount() {
        this.messagesRef.off();
    }

    handleDialogOpen = () => {
        this.setState({dialog_open: true});
    };

    handleDialogClose = () => {
        this.setState({dialog_open: false});
    };

    handleDialogCreate = () => {
        let orgKey = this.refs.orgName.value;
        let data = {};
        data['user_orgs/'+this.props.user.uid+'/'+orgKey]=true;
        data['organizations/'+orgKey+'/name']=orgKey;
        firebase_connection.database().ref().update( data, error => {
            if (error) {
                error_handler(error);
                this.refs.errorMsg.innerHTML = "Already exists. Please choose a different name";
            }
            else
                this.handleDialogClose();
        } );
    };

    render = () => {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleDialogClose}
            />,
            <FlatButton
                label="Create"
                primary={true}
                keyboardFocused={true}
                onTouchTap={this.handleDialogCreate}
            />,
        ];

        return (
            <div>
                <ul>
                    {
                        this.state.organizations.map( org => <li key={org.id}><Link to={'/'+org.id}>{org.org.name}</Link></li> )
                    }
                </ul>
                <FloatingActionButton onClick={this.handleDialogOpen}>
                    <ContentAdd />
                </FloatingActionButton>
                <Dialog
                    title="Create Organization"
                    actions={actions}
                    modal={true}
                    open={this.state.dialog_open}
                    onRequestClose={this.handleDialogClose}
                >
                    Name of Organization: <input ref="orgName"/>
                    <div ref="errorMsg"/>
                </Dialog>
            </div>
        )
    };
};

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js